import React from 'react'

import Title from '../../UI/Title/Title';
import '../../../style/Buttons.css'

import { Button, RadioGroup, Radio, FormControlLabel } from '@material-ui/core'



export default function Gender(props) {
    const nextPage = () => {
        props.history.push('./insruction')
    }





    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: '30%'
        }}>
            <Title>
                你覺得你自己是？
            </Title>
            <div style={{
                margin: "8em auto 4em auto",
                textAlign: "center",
                width: "60%"
            }}>
                <RadioGroup
                style={{
                    matgin: "0 auto"
                }}
                aria-label="gender"
                name="gender1"
                value={props.gender}
                onChange={(event) => props.setGender(event.target.value)}>
                <FormControlLabel value="female" control={<Radio />} label="我是女生" />
                <FormControlLabel value="male" control={<Radio />} label="我是男生" />
                <FormControlLabel value="other" control={<Radio />} label="我是其他" />
            </RadioGroup>

            </div>
            <div className='buttons-container'>
                <Button
                variant="outlined"
                color="primary"
                onClick={nextPage}
                fullWidth>OK
                </Button>
             </div>



        </div>
    )
}
